module.exports = __webpack_public_path__ + "static/img/quality_bg.91d840e3.png";